import { createAppReducerSimpleFetch } from "shared/redux-store/defaults";
import reduceReducers from "reduce-reducers";
import {
  defaultInitialState,
  defaultSubmitRequestState,
  defaultSubmitReceiveSuccessState,
  defaultSubmitReceiveErrorState,
} from "shared/redux-store/defaultAppReducerParts";

import { intl } from "shared/storeInfo";

const retrieveSubmitSuccessMessage = action => {
  switch (action.meta && action.meta.productUpdateType) {
    case "ADD":
    case "UPDATE":
    case "REMOVE":
      return intl(
        `interaction.success.orderUnitProductUpdate.${action.meta.productUpdateType}`,
      );
    default:
      return intl(`interaction.success.orderUnitProductUpdate`);
  }
};

const orderUnitDetailsAppReducerFetch = createAppReducerSimpleFetch(
  "ORDER_UNIT_DETAILS",
  ["orderUnit", "products"],
);

function orderUnitDetailsAppReducerSubmit(
  state = defaultInitialState(),
  action,
) {
  switch (action.type) {
    case "SUBMIT_ORDER_UNIT_DETAILS_PRODUCTS_PENDING":
      return {
        ...state,
        ...defaultSubmitRequestState(state, action),
      };
    case "SUBMIT_ORDER_UNIT_DETAILS_PRODUCTS_FULFILLED":
      return {
        ...state,
        ...defaultSubmitReceiveSuccessState(state, action, ["orderUnit"]),
        submitSuccessMessage: retrieveSubmitSuccessMessage(action),
      };
    case "SUBMIT_ORDER_UNIT_DETAILS_PRODUCTS_REJECTED":
      return {
        ...state,
        ...defaultSubmitReceiveErrorState(state, action),
      };
    case "SUBMIT_ORDER_UNIT_DETAILS_REQUEST_APPROVAL_PENDING":
      return {
        ...state,
        ...defaultSubmitRequestState(state, action),
      };
    case "SUBMIT_ORDER_UNIT_DETAILS_REQUEST_APPROVAL_FULFILLED":
      return {
        ...state,
        ...defaultSubmitReceiveSuccessState(state, action, ["orderUnit"]),
        submitSuccessMessage: intl(
          "interaction.success.orderUnitRequestApproval",
        ),
      };
    case "SUBMIT_ORDER_UNIT_DETAILS_REQUEST_APPROVAL_REJECTED":
      return {
        ...state,
        ...defaultSubmitReceiveErrorState(state, action),
      };
    default:
      return state;
  }
}

export default reduceReducers(
  orderUnitDetailsAppReducerFetch,
  orderUnitDetailsAppReducerSubmit,
);
